"use client"
import { useState } from "react"
import Image from "next/image"
import { Button } from "@/components/ui/button"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  type CarouselApi,
} from "@/components/ui/carousel"
import Autoplay from "embla-carousel-autoplay" // Import Autoplay plugin
import image_1 from '@/assets/section/section-2.webp'
import image_2 from '@/assets/section/section-3.webp'
import image_4 from '@/assets/section/section-5.webp'
import image_5 from '@/assets/section/section-6.webp'
import image_6 from '@/assets/section/section-7.webp'

export default function AboutSection() {
  const images = [
    image_1,
    image_2,
    image_4,
    image_5,
    image_6,
  ]

  const [api, setApi] = useState<CarouselApi>()

  // Initialize Autoplay plugin
  const autoplayPlugin = Autoplay({
    delay: 3000, // Auto-scroll every 3 seconds
    stopOnInteraction: false, // Keep auto-scrolling even if user interacts
  })

  return (
    <section className="w-full bg-[#273647] text-white py-12 md:py-20 lg:py-24">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        {/* Image Slider */}
        <div className="relative w-full h-[300px] md:h-[450px] lg:h-[550px] overflow-hidden rounded-lg shadow-lg">
          <Carousel
            setApi={setApi}
            opts={{
              loop: true, // Enable looping for continuous scroll
            }}
            plugins={[autoplayPlugin]} // Add the Autoplay plugin
            className="w-full h-full"
          >
            <CarouselContent className="h-full">
              {images.map((imageSrc, index) => (
                <CarouselItem key={index} className="h-[300px] md:h-[450px] lg:h-[550px]">
                  <div className="relative w-full h-full">
                    <Image
                      src={imageSrc || "/placeholder.svg"}
                      alt={`Factory image ${index + 1}`}
                      fill
                      className="transition-opacity duration-500 ease-in-out object-cover"
                      priority
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2" />
            <CarouselNext className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2" />
          </Carousel>
        </div>
        {/* Text Content */}
        <div className="flex flex-col justify-center">
          <p className="text-sm font-semibold uppercase text-gray-400 mb-2">GIỚI THIỆU</p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Sợi Cửu Long
            <span className="block w-16 h-1 bg-[#FDCB2C] mt-2" />
          </h2>
          <p className="text-base md:text-lg text-gray-300 mb-6 leading-relaxed">
            Công ty Cổ phần Sợi Cửu Long là nhà sản xuất sợi Polypropylene (PP) Multifilament cường lực hàng đầu, cam
            kết cung cấp sản phẩm có chất lượng vượt trội. Với phương châm “Chất lượng là sự sống còn”, chúng tôi không
            ngừng cải tiến công nghệ và quy trình sản xuất để đáp ứng tối đa nhu cầu của khách hàng. Được xây dựng trên
            nền tảng phát triển bền vững, Sợi Cửu Long luôn tập trung tối ưu chi phí, đồng thời đảm bảo sản phẩm đạt
            tiêu chuẩn cao nhất.
          </p>
          <Button className="w-fit px-6 py-3 bg-white text-[#263238] hover:bg-gray-200 transition-colors duration-200">
            THÔNG TIN THÊM
          </Button>
        </div>
      </div>
    </section>
  )
}
